import { render, staticRenderFns } from "./hero-section.vue?vue&type=template&id=7a5142a8&scoped=true"
import script from "./hero-section.vue?vue&type=script&lang=ts"
export * from "./hero-section.vue?vue&type=script&lang=ts"
import style0 from "./hero-section.vue?vue&type=style&index=0&id=7a5142a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5142a8",
  null
  
)

export default component.exports